import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoAlteracaoPrecoSchema } from '../types/ProdutoAlteracaoPreco';

type ApiProdutoAlteracaoPrecoGetParams = Partial<
    DefaultApiParams & {
        alp_data_insercao?: string;
        alp_usuario_nome?: string | null;
        alp_descricao?: string | null;
        alp_preco_antigo?: number;
        alp_preco_novo?: number;
        tipo?: string;
    }
>;

const schema = registrosSchema(ProdutoAlteracaoPrecoSchema);

export function apiProdutoAlteracaoPrecoGet(params: ApiProdutoAlteracaoPrecoGetParams) {
    return fetchApi({
        endpoint: 'Produto/AlteracoesDePreco',
        method: 'get',
        params,
        schema,
    });
}
